(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npr-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-npr-ann]').forEach(function(v){
    var msgs=v.querySelectorAll('[data-npr-ann-msg]'); if(msgs.length<2)return;
    var i=0, ms=parseInt(v.dataset.autoplay,10);
    if(!ms)return;
    setInterval(function(){ msgs[i].classList.remove('is-active'); i=(i+1)%msgs.length; msgs[i].classList.add('is-active'); }, ms);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npr-faq"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.npr-faq [data-npr-faqtabs]').forEach(function(tabs){
      var sec=tabs.closest('.npr-faq');
      tabs.querySelectorAll('[data-npr-faqtab]').forEach(function(tab){
        tab.addEventListener('click',function(){
          var cat=tab.getAttribute('data-npr-faqtab');
          tabs.querySelectorAll('[data-npr-faqtab]').forEach(function(t){var on=t===tab;t.classList.toggle('is-active',on);t.setAttribute('aria-selected',on);});
          sec.querySelectorAll('[data-npr-faqcat]').forEach(function(it){var show=it.getAttribute('data-npr-faqcat')===cat;it.hidden=!show;if(!show)it.open=false;});
        });
      });
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npr-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-npr-gallery]').forEach(function (g) {
      var slides = g.querySelectorAll('[data-npr-slide]');
      var thumbs = g.querySelectorAll('[data-npr-thumb]');
      var current = 0;
      function show(i) {
        current = i;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); t.setAttribute('aria-selected', n === i); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.dataset.nprThumb, 10)); }); });
      function go(delta) { var n = slides.length; if (!n) return; show((current + delta + n) % n); }
      var navPrev = g.querySelector('[data-npr-prev]');
      var navNext = g.querySelector('[data-npr-next]');
      if (navPrev) navPrev.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
      if (navNext) navNext.addEventListener('click', function (e) { e.stopPropagation(); go(1); });

      // Lightbox
      var section = g.closest('.npr-hero-section');
      var box = section && section.querySelector('[data-npr-lightbox]');
      var boxImg = box && box.querySelector('[data-npr-lightbox-img]');
      var stage = g.querySelector('[data-npr-gallery-stage]');
      function openBox() {
        if (!box || !boxImg) return;
        var active = g.querySelector('.npr-gallery__slide.is-active .npr-gallery__img');
        if (!active) return;
        boxImg.src = active.getAttribute('data-npr-full') || active.currentSrc || active.src;
        box.hidden = false;
        document.body.style.overflow = 'hidden';
        var close = box.querySelector('[data-npr-lightbox-close]');
        if (close) close.focus();
      }
      function closeBox() { if (!box) return; box.hidden = true; document.body.style.overflow = ''; }
      if (stage) {
        stage.addEventListener('click', openBox);
        stage.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openBox(); } else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); } else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); } });
      }
      if (box) {
        box.addEventListener('click', function (e) { if (e.target === box || e.target.hasAttribute('data-npr-lightbox-close')) closeBox(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) closeBox(); });
      }
    });
  })();

  (function () {
    document.querySelectorAll('[data-npr-sizechart]').forEach(function (modal) {
      var sectionEl = modal.closest('.npr-hero-section');
      if (!sectionEl) return;
      function openSC() { modal.hidden = false; document.body.style.overflow = 'hidden'; var c = modal.querySelector('[data-npr-sizechart-close]'); if (c) c.focus(); }
      function closeSC() { modal.hidden = true; document.body.style.overflow = ''; }
      sectionEl.querySelectorAll('[data-npr-sizechart-open]').forEach(function (btn) { btn.addEventListener('click', function (e) { e.preventDefault(); openSC(); }); });
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.hasAttribute('data-npr-sizechart-close')) closeSC(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeSC(); });
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npr-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-npr-sticky]').forEach(function(bar){
    var after=parseInt(bar.dataset.showAfter,10)||600;
    function onScroll(){var y=window.scrollY||document.documentElement.scrollTop;var show=y>after;bar.classList.toggle('is-visible',show);bar.setAttribute('aria-hidden',show?'false':'true');}
    window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
    // Reserve space below the page content so the fixed bar never covers the footer.
    // A spacer placed right after the footer lives in the scroll flow, so it works whether
    // the page scrolls on <html>/window or on an inner scroll container.
    function reserve(){
      var shown = window.getComputedStyle(bar).display !== 'none';
      var h = shown ? bar.offsetHeight : 0;
      var sp = document.getElementById('npr-sticky-spacer');
      if(h<=0){ if(sp){ sp.style.height='0px'; } return; }
      if(!sp){
        sp=document.createElement('div');
        sp.id='npr-sticky-spacer';
        sp.setAttribute('aria-hidden','true');
        sp.style.width='100%';
        sp.style.flex='0 0 auto';
        sp.style.pointerEvents='none';
        var fs=document.querySelectorAll('footer');
        var f=fs[fs.length-1];
        if(f && f.parentNode){ f.parentNode.insertBefore(sp, f.nextSibling); }
        else { document.body.appendChild(sp); }
      }
      sp.style.height=h+'px';
    }
    reserve();
    window.addEventListener('resize', reserve, {passive:true});
    window.addEventListener('load', reserve);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(reserve); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npr-ugc-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-npr-ugc]').forEach(function (root) {
      var track = root.querySelector('[data-npr-ugc-track]');
      if (!track) return;
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-npr-ugc-card]'));
      var videos = Array.prototype.slice.call(root.querySelectorAll('[data-npr-ugc-video]'));

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { en.target.play().catch(function () {}); }
            else { en.target.pause(); }
          });
        }, { root: track, threshold: 0.5 });
        videos.forEach(function (v) { io.observe(v); });
      } else {
        videos.forEach(function (v) { v.play().catch(function () {}); });
      }

      function toggleSound(card, v) {
        if (v.muted) {
          videos.forEach(function (o) {
            if (o !== v) { o.muted = true; var oc = o.closest('[data-npr-ugc-card]'); if (oc) oc.classList.remove('is-unmuted'); }
          });
          v.muted = false; v.play().catch(function () {});
          card.classList.add('is-unmuted');
        } else {
          v.muted = true; card.classList.remove('is-unmuted');
        }
      }
      cards.forEach(function (card) {
        var v = card.querySelector('[data-npr-ugc-video]');
        var btn = card.querySelector('[data-npr-ugc-sound]');
        if (v) v.addEventListener('click', function () { if (!track.__dragged) toggleSound(card, v); });
        if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); if (v) toggleSound(card, v); });
      });

      function step(dir) {
        var card = cards[0]; if (!card) return;
        var amt = card.getBoundingClientRect().width + 16;
        track.scrollBy({ left: dir * amt, behavior: 'smooth' });
      }
      var prev = root.querySelector('[data-npr-ugc-prev]');
      var next = root.querySelector('[data-npr-ugc-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      var down = false, startX = 0, startScroll = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse') { down = true; track.__dragged = false; startX = e.clientX; startScroll = track.scrollLeft; track.classList.add('is-dragging'); }
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return; var dx = e.clientX - startX; if (Math.abs(dx) > 5) track.__dragged = true; track.scrollLeft = startScroll - dx;
      });
      function up() { down = false; track.classList.remove('is-dragging'); setTimeout(function () { track.__dragged = false; }, 30); }
      track.addEventListener('pointerup', up); track.addEventListener('pointerleave', up);
    });
  })();
  
  } catch(e) { console.error(e); }
})();
})();
